import React, { Component } from 'react';
import { connect }          from 'react-redux';
import $                    from 'jquery';
import { ActionModal }      from '../../../actions/scopoAction';
import Avata_p              from '../../../container/render_avatar_p';
import FlashCarregando      from '../../../container/FlashCarregando';
import FlashRetornoNulo     from '../../../container/FlashRetornoNulo';
import {SetError}           from '../../../actions/authenticActions';
import { GetUsuarios, 
         SetByIniciarDuelo,
        GetDuelosAbertos }  from '../../../actions/batalhaAction';
import '../../../css/aluno/batalha/batalha-box.css';

class Batalha_Convidar_Oponente extends Component {

    constructor(props){
        super(props);
        this.state = {
                      usu_id : this.props.session.id,
                      cur_id : this.props.session.curso,
                      listaUser:[],
                      filterUsuario:"",
                      checkAluno:null,
                      load1:false,
                      load2:false,
                    };
        this.updateState = this.updateState.bind(this);
    }

    updateState(e){
       this.setState({filterUsuario: e.target.value});
    }

    checkAluno(val){
       this.setState({checkAluno:val});
    }

    renderGetAlunos(){
        if (this.state.filterUsuario) {
            this.setState({load1:true,listaUser:<FlashCarregando/>,checkAluno:null});
            this.props.GetUsuarios(this.state.cur_id,this.state.filterUsuario).then((response) => {
                this.setState({listaUser2:response.data,filterUsuario:""}); 
                this.renderItemAluno();            
          } ).catch((error) =>{
             this.props.SetError(500);
          });            
        }       
    }

    renderItemAluno(){

            const data = this.state.listaUser2;
            if (data.length>0) {

                const lista =   data.map((elem,i)=>{
                    return <a href="javascript:void(0)" onClick={this.checkAluno.bind(this,elem.use_id)} id={elem.use_id} className="battle-box-search-result" key={i}>
                                <div className="battle-box-search-result-avatar">
                                    <Avata_p Foto={elem.use_foto}/>
                                </div>
                                <div className="battle-box-search-result-info" id={`elem_check_${elem.use_id}`}>
                                <div className="battle-box-search-result-info-name">{elem.use_nome}</div>
                                <div className="battle-box-search-result-info-extra">Turma F025462556</div>
                            </div>
                        </a>
                });

                this.setState({listaUser:  <div className="battle-box-search-results">{lista}</div>});
            }else{
                this.setState({listaUser:<FlashRetornoNulo/>});        
            }
        
    }

    componentDidUpdate() {
        $('.battle-box-search-results a').on('click', function(event){
            $('.battle-box-search-result-info').attr('style',"");
            $("#elem_check_"+event.target.id).attr('style',"border: 2px #00ffff solid;");
        });
    }

    handleSubmit() {

        if (this.state.checkAluno) {
         
            this.props.SetByIniciarDuelo(
                                          this.state.checkAluno,
                                          //this.state.optionVal,
                                          1,
                                          this.state.usu_id,
                                          this.state.cur_id
                                         ).then(
            (response) =>{

                        alert('Cadastrado realizado com sucesso!');
                        this.props.ActionModal(false);
                }
            ).catch((error) =>{

             this.props.SetError(500);

            });
        }

    }

    render() {
        const wid = {"width": "100%"}

        return (
             <div className="box box-primary box-border-primary box-medium box-auto box-fixed box-fitted" data-reference=".battle-card-matches">
                        <div className="box-header">
                            <div className="box-header-decoration"></div>
                            <div className="box-header-info">
                                <div className="box-header-info-tools">
                                <a href={void(0)} onClick={()=>this.props.ActionModal(false)} className="simple-action">&times;</a>
                                </div>
                            </div>
                        </div>
                        <div className="box-body">
                            <div className="battle-box">
                                <form className="battle-box-search-bar">
                                    <div className="battle-box-search-input">
                                        <input type="text" value = {this.state.filterUsuario} onChange = {this.updateState} placeholder="BUSCAR OPONENTE"/>
                                        <button type="button" onClick={this.renderGetAlunos.bind(this)} className="action action-simple action-icon">
                                            <i className="gamefica-icon gamefica-search primary"></i>
                                        </button>
                                    </div>
                                    {/* <div className="battle-box-search-filters">
                                        <div className="battle-box-search-filter">
                                            <input type="radio" id="1-semestre" name="filtro"/>
                                            <label>1º Semestre</label>
                                        </div>
                                        <div className="battle-box-search-filter">
                                            <input type="radio" id="2-semestre" name="filtro"/>
                                            <label>2º Semestre</label>
                                        </div>
                                        <div className="battle-box-search-filter">
                                            <input type="radio" id="3-semestre" name="filtro"/>
                                            <label>3º Semestre</label>
                                        </div>
                                        <div className="battle-box-search-filter">
                                            <input type="checkbox" id="4-semestre" name="filtro"/>
                                            <label>4º Semestre</label>
                                        </div>
                                        <div className="battle-box-search-filter">
                                            <input type="checkbox" id="todos" name="filtro"/>
                                            <label>Todos</label>
                                        </div>
                                    </div> */}
                                </form>
                                {this.state.load1? this.state.listaUser:""}
                              
                                {this.state.checkAluno?  <div className="battle-box-actions">
                                    {/* <a href="javascript:void(0)" className="action action-limitless">Sorteadr Oponente</a> */}
                                <a href="javascript:void(0)" onClick={this.handleSubmit.bind(this)} className="action action-limitless">Selecionar</a>
                                </div>:""} 
                            </div>
                        </div>
                    </div>
        );
    }
}

function mapStateToProps(state) {

    return { 
            session : state.auth.session,
            menu    : state.configReducer.menu,
           }
}

export default connect(mapStateToProps,{ActionModal,
                                        GetUsuarios, 
                                        SetByIniciarDuelo,
                                        SetError,
                                        GetDuelosAbertos })(Batalha_Convidar_Oponente);




// WEBPACK FOOTER //
// ./src/components/aluno/batalha/batalha_convidar_oponente.js